<template>
    <div class="text-center my-5">
        <div class="d-inline-block">
            <h1 class="mb-3">
                Programming Jokes
                <v-btn
                    x-small
                    icon
                    class="mb-4"
                    color="info"
                    @click="showTip = !showTip"
                >
                    <v-icon>mdi-information-outline</v-icon>
                </v-btn>
            </h1>
            <transition name="fade">
                <v-alert
                    v-if="showTip"
                    border="left"
                    color="info"
                    icon="mdi-information-outline"
                    elevation="1"
                    align="left"
                    close-text="Close this information box"
                    colored-border
                    dense
                >
                    <div>Programming Jokes are fetched from <a href="https://v2.jokeapi.dev/" target="_blank">JokesAPI.dev</a> API Endpoint</div>
                    <div class="text-right mt-3">
                        <v-btn
                            x-small
                            color="grey lighten-2"
                            elevation="0"
                            @click="showTip = false"
                        >
                            Close
                        </v-btn>
                    </div>
                </v-alert>
            </transition>
        </div>
        <transition name="fade" mode="out-in">
            <div v-if="!joke" key="isLoading" class="mt-10">Fetching joke...</div>
            <div v-else :key="joke.id" class="mt-7">
                <div v-if="joke.joke">
                    <QuoteBubble
                        :selected-quote="joke.joke"
                        quote-author="(Badumm tss...)"
                    />
                </div>
                <div v-else>
                    <QuoteBubble
                        :selected-quote="joke.setup"
                        :quote-author="joke.delivery"
                    />
                </div>
                <div class="mt-15">
                    <div class="mb-3">
                        <div class="text-h5">🤣 🤣 🤣</div>
                    </div>
                    <v-btn @click="fetchJoke">
                        New Joke
                        <v-icon right>mdi-refresh</v-icon>
                    </v-btn>
                </div>
                <div class="mt-6" style="opacity:.35;"><small>Joke #{{ joke.id }}</small></div>
            </div>
        </transition>
    </div>
</template>

<script>
    import QuoteBubble from '../components/QuoteBubble';

    export default {
        components: {
            QuoteBubble,
        },

        data() {
            return {
                showTip: false,
                joke: undefined,
            };
        },

        created() {
            this.fetchJoke();
        },

        methods: {
            async fetchJoke() {
                // JOKE API DOCUMENTATION: https://v2.jokeapi.dev/#getting-started
                await fetch('https://v2.jokeapi.dev/joke/Programming')
                    .then((response) => response.json())
                    .then((data) => this.joke = data)
                    .catch((error) => console.error(error));
            },
        },
    };
</script>
